$(document).ready(function () {
  $("body").on(
    "click",
    ".option.product_plp_swatches .color.color_plp",
    function (e) {
      e.preventDefault();
      console.log("sssss");
      $(this)
        .closest(".option.product_plp_swatches")
        .find(".color_plp")
        .removeClass("current-selected");
      $(this).addClass("current-selected");
      var productUrl = $(this).data("url") + ".json";
      var _this = $(this);
      $.getJSON(productUrl, function (response) {
        console.log(response.product);

        if (response.product.images.length > 0) {
          _this
            .closest(".product-button__inner")
            .find(".image-holder__image")
            .find("img")
            .attr("src", response.product.images[0].src);

          _this
            .closest(".product-button__inner")
            .find(".image-holder__image")
            .find("img")
            .removeAttr("srcset");
        }
        if (response.product.images.length > 1) {
          _this
            .closest(".product-button__inner")
            .find(".image-holder__image--hover")
            .find("img")
            .attr("src", response.product.images[1].src);
        }
        _this
          .closest(".product-button__inner")
          .find("wishlist-button")
          .find("button")
          .attr("data-product-id", response.product.id);
        _this
          .closest(".product-button__inner")
          .find("wishlist-button")
          .find("button")
          .attr("data-product-handle", response.product.handle);
        var wishlist = JSON.parse(
          localStorage.getItem("Suite702_wishlist") || "[]"
        );

        var exists = wishlist.some(
          (item) => item.handle === response.product.handle
        );
        if (exists) {
          _this
            .closest(".product-button__inner")
            .find("wishlist-button")
            .find("button")
            .addClass("is-active");
        } else {
          _this
            .closest(".product-button__inner")
            .find("wishlist-button")
            .find("button")
            .removeClass("is-active");
        }

        var newHref = "/products/" + response.product.handle;
        _this
          .closest(".product-button__inner")
          .find("a")
          .each(function (index, val) {
            if (!$(val).hasClass("color_plp")) {
              $(val).attr("href", newHref);
            }
          });
      });
    }
  );


    waitForReviewsToLoad();
 
   if (window.StampedFn) {
     if (typeof window.StampedFn.loadBadges === 'function') {
         window.StampedFn.loadBadges();
     }
 }
 function waitForReviewsToLoad(attempts = 50) {
   document.querySelectorAll("article.product-button").forEach(el => { 
     el.classList.add('find_it_plp'); 
     el.querySelectorAll('.stamped-fa').forEach(star => star.removeAttribute("style"));
 });
 
 setTimeout(() => waitForReviewsToLoad(attempts - 1), 500); 
 }
 
});
